import Vue from 'vue';
import VueMoment from 'vue-moment';
import moment from 'moment-timezone';
import * as FontAwesome from '@fortawesome/fontawesome-svg-core';
import * as VueGoogleMaps from 'vue2-google-maps';
import BootstrapVue from 'bootstrap-vue';
import {
  faClipboard,
  faTh,
  faSlidersH,
  faFlag,
  faAngleRight,
  faAngleLeft,
  faAngleDown,
  faAngleUp,
  faTimesCircle,
  faTimes,
  faFilter,
  faSearch,
  faFileExport,
  faPrescriptionBottle,
  faChartPie,
  faFileAlt,
  faVials,
  faArrowRight,
  faCloudDownloadAlt,
  faFilePdf,
  faCog,
  faUsers,
  faPlus,
  faLock,
  faBars,
  faEllipsisH,
  faArrowCircleRight,
  faArrowCircleLeft,
  faBan,
  faPlusCircle,
  faUserLock,
  faEnvelope,
  faPlusSquare,
  faMinusSquare,
  faCheckCircle,
  faExclamationCircle,
  faMinusCircle,
  faPencilAlt,
  faSpinner,
  faFileCsv,
  faPhone,
  faExternalLinkAlt,
  faMapMarkerAlt,
} from '@fortawesome/free-solid-svg-icons';
import {
  FontAwesomeIcon,
} from '@fortawesome/vue-fontawesome';

import App from './App.vue';
import router from './router';

// more fontawesome stuff
FontAwesome.library.add(
  faClipboard,
  faTh,
  faSlidersH,
  faFlag,
  faAngleRight,
  faAngleLeft,
  faAngleDown,
  faAngleUp,
  faTimesCircle,
  faTimes,
  faFilter,
  faSearch,
  faBars,
  faArrowCircleRight,
  faArrowCircleLeft,
  faFileExport,
  faPrescriptionBottle,
  faChartPie,
  faFileAlt,
  faVials,
  faArrowRight,
  faCloudDownloadAlt,
  faFilePdf,
  faCog,
  faUsers,
  faPlus,
  faPlusCircle,
  faLock,
  faEllipsisH,
  faBan,
  faUserLock,
  faEnvelope,
  faPlusSquare,
  faMinusSquare,
  faCheckCircle,
  faExclamationCircle,
  faMinusCircle,
  faPencilAlt,
  faSpinner,
  faFileCsv,
  faEnvelope,
  faPhone,
  faExternalLinkAlt,
  faMapMarkerAlt,
);

Vue.use(BootstrapVue);
Vue.use(VueMoment, {
  moment,
});
Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_MAP_KEY,
    libraries: 'places',
  },
});

Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.config.productionTip = false;

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app');
